<div *ngIf="showWidgets()" class="table-widgets">
  <a *ngIf="hasSubstrates" (click)="sendToQueryBuilder()">{{sendSubstratesText()}}</a>
  <a *ngIf="hasDownstreamGenes" (click)="sendDownstreamGenesToQueryBuilder()">
    {{typeConfig.downstream_query_title}}
  </a>
</div>
